import { css } from '@emotion/react';

import { makeStyles } from '@toolbox/style';
import { Flex, FlexItem } from '../Flex';

const useStyles = makeStyles(() => ({
  container: css`
    list-style-type: none;
    flex: 0 0 100%;
    text-align: center;
  `,
}));

type DayProps = {
  dateText: string;
};

export function Day({ dateText }: DayProps): JSX.Element {
  const classes = useStyles();

  return (
    <Flex justifyContent="center" css={classes.container as any}>
      <FlexItem>{dateText}</FlexItem>
    </Flex>
  );
}
